// extracted by mini-css-extract-plugin
export default {"callButton":"callButton_callButton__vkN4Y","icon":"callButton_icon__WhkGG"};